export enum FirebaseErrorAuth {
  CAPTCHA_CHECK_FAILED = 'auth/captcha-check-failed',
  INVALID_VERIFICATION_CODE = 'auth/invalid-verification-code',
  INVALID_VERIFICATION_ID = 'auth/invalid-verification-id',
  NETWORK_REQUEST_FAILED = 'auth/network-request-failed',
  QUOTA_EXCEEDED = 'auth/quota-exceeded',
  TOO_MANY_ATTEMPTS_TRY_LATER = 'TOO_MANY_ATTEMPTS_TRY_LATER',
  USER_DISABLED = 'auth/user-disabled',
}
